// Viclara – samlet JavaScript

var sideProd = jQuery('.side-product');

jQuery(sideProd).mouseenter(function() {
  var dataNum = jQuery(this).attr('data-number');
  var prodDot = jQuery('.hotspot-' + dataNum);

  jQuery(prodDot).addClass('prodDotEffect');
});

jQuery(sideProd).mouseleave(function() {
  var dataNum = jQuery(this).attr('data-number');
  var prodDot = jQuery('.hotspot-' + dataNum);

  jQuery(prodDot).removeClass('prodDotEffect');
});

function myFunction() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var btnText = document.getElementById("myBtn");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnText.innerHTML = "Læs mere";
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = "Læs mindre";
    moreText.style.display = "inline";
  }
}

if ($('#search_reveal').is(':visible') == false) {
  console.log('not vis');

  $('.mobile-seeks').on('click', function() {
    $('#search_reveal').css('display', 'block');
  });
} else if ($('#search_reveal').is(':visible') == true) {
  console.log('VIS');

  $('.mobile-seeks').on('click', function() {
    $('#search_reveal').css('display', 'none');
  });
}

var baseUrl = "https://shop-viclara.myshopify.com";

$('.swatch-element').on('click', function() {
  var prodId = $(this).attr('data-id');
});

// Lagerstatus ved variantskift – seks sprog

jQuery(function ($) {
  'use strict';

  if (window.viclaraInventoryLocalized) return;
  window.viclaraInventoryLocalized = true;

  var states = new WeakMap();

  var messages = {
    da: {
      stock: 'På lager: Levering {days} hverdage',
      low: 'Kun {count} på lager: Levering {days} hverdage',
      remote: 'Bestillingsvare: Forventet levering {days} hverdage',
      sold: 'Udsolgt – kontakt os for levering.',
      unavailable: 'Denne variant er ikke tilgængelig.'
    },

    de: {
      stock: 'Auf Lager: Lieferung {days} Werktage',
      low: 'Nur {count} auf Lager: Lieferung {days} Werktage',
      remote: 'Bestellware: Voraussichtliche Lieferung {days} Werktage',
      sold: 'Ausverkauft – kontaktieren Sie uns zur Lieferzeit.',
      unavailable: 'Diese Variante ist nicht verfügbar.'
    },

    nl: {
      stock: 'Op voorraad: levering {days} werkdagen',
      low: 'Nog slechts {count} op voorraad: levering {days} werkdagen',
      remote: 'Op bestelling: verwachte levertijd {days} werkdagen',
      sold: 'Uitverkocht – neem contact met ons op over de levertijd.',
      unavailable: 'Deze variant is niet beschikbaar.'
    },

    sv: {
      stock: 'I lager: leverans {days} arbetsdagar',
      low: 'Endast {count} kvar i lager: leverans {days} arbetsdagar',
      remote: 'Beställningsvara: beräknad leverans {days} arbetsdagar',
      sold: 'Slutsåld – kontakta oss för leveranstid.',
      unavailable: 'Den här varianten är inte tillgänglig.'
    },

    fi: {
      stock: 'Varastossa: toimitus {days} arkipäivässä',
      low: 'Vain {count} kpl varastossa: toimitus {days} arkipäivässä',
      remote: 'Tilaustuote: arvioitu toimitusaika {days} arkipäivää',
      sold: 'Loppuunmyyty – ota yhteyttä toimitusajan selvittämiseksi.',
      unavailable: 'Tämä tuotevaihtoehto ei ole saatavilla.'
    },

    en: {
      stock: 'In stock: delivery in {days} working days',
      low: 'Only {count} left in stock: delivery in {days} working days',
      remote: 'Pre-order: estimated delivery in {days} working days',
      sold: 'Sold out – contact us for delivery information.',
      unavailable: 'This variant is unavailable.'
    }
  };

  function getState(form) {
    if (!form) return null;
    if (states.has(form)) return states.get(form);

    var dataNode = form.querySelector('.viclara-inventory-data');
    if (!dataNode) return null;

    var data;

    try {
      data = JSON.parse(dataNode.textContent);
    } catch (error) {
      return null;
    }

    if (!Array.isArray(data.variants)) return null;

    var language = String(
      data.language || document.documentElement.lang || 'en'
    ).toLowerCase().split(/[-_]/)[0];

    if (language === 'se') language = 'sv';

    var variants = Object.create(null);

    data.variants.forEach(function (variant) {
      variants[String(variant.id)] = variant;
    });

    var state = {
      data: data,
      variants: variants,
      text: messages[language] || messages.en,
      timer: null
    };

    states.set(form, state);

    return state;
  }

  function format(text, days, count) {
    return text
      .replace('{days}', days)
      .replace('{count}', String(count));
  }

  function update(form, state) {
    if (!form.isConnected) return;

    var field = form.querySelector(
      'select[name="id"], input[name="id"]'
    );

    var panel = form.querySelector('.inventory-msg.normal');

    if (!field || !panel) return;

    var variant = state.variants[String(field.value)];
    var quantity = variant ? Number(variant.quantity) : 0;
    var days = state.data.deliveryDays || '2–5';
    var status;
    var text;

    if (!variant) {
      status = 'out-of-stock';
      text = state.text.unavailable;

    } else if (
      !variant.available ||
      (state.data.tagSoldOut && quantity <= 0)
    ) {
      status = 'out-of-stock';
      text = state.text.sold;

    } else if (variant.tracked && quantity <= 0) {
      status = 'remote-stock';

      text = format(
        state.text.remote,
        state.data.tissot ? '4–12' : '3–9',
        0
      );

    } else if (variant.tracked && quantity <= 3) {
      status = 'low-stock';
      text = format(state.text.low, days, quantity);

    } else {
      status = 'in-stock';
      text = format(state.text.stock, days, quantity);
    }

    var row = panel.querySelector(
      '.stock-status:not(.click-collect)'
    );

    if (!row) {
      row = document.createElement('p');
      row.className = 'stock-status';
      panel.insertBefore(row, panel.firstChild);
    }

    var dot = row.querySelector('.pulse-dot');

    if (!dot) {
      dot = document.createElement('span');
      dot.className = 'pulse-dot';
      dot.setAttribute('aria-hidden', 'true');
      row.insertBefore(dot, row.firstChild);
    }

    var label = row.querySelector('.stock-text');

    if (!label) {
      label = document.createElement('span');
      label.className = 'stock-text';
      row.appendChild(label);
    }

    row.classList.remove(
      'in-stock',
      'low-stock',
      'remote-stock',
      'out-of-stock'
    );

    row.classList.add(status);

    if (label.textContent !== text) {
      label.textContent = text;
    }
  }

  function schedule(form) {
    var state = getState(form);
    if (!state) return;

    if (state.timer !== null) {
      window.clearTimeout(state.timer);
    }

    state.timer = window.setTimeout(function () {
      state.timer = null;
      update(form, state);
    }, 0);
  }

  function initialize(root) {
    if (root.matches && root.matches('form.product_form')) {
      schedule(root);
    }

    root.querySelectorAll('form.product_form').forEach(schedule);
  }

  $(document).on(
    'change.viclaraInventoryLocalized',
    'form.product_form select, form.product_form input',
    function () {
      if (
        this.name === 'id' ||
        this.classList.contains('single-option-selector') ||
        this.closest('.swatch-element')
      ) {
        schedule(this.closest('form'));
      }
    }
  );

  $(document).on(
    'click.viclaraInventoryLocalized',
    'form.product_form .swatch-element',
    function () {
      schedule(this.closest('form'));
    }
  );

  $(document).on(
    'shopify:section:load.viclaraInventoryLocalized',
    function (event) {
      initialize(event.target);
    }
  );

  initialize(document);
});

// Eksisterende kollektionsfunktioner

var selectors = {
  colorSwatchImage: '.grid-product__color-image',
  colorSwatch: '.color-swatch--with-image',
  sortSelect: '#SortBy'
};

var data = {
  sortBy: 'data-default-sortby'
};

function Collection(container) {
  this.container = container;
  this.sectionId = $(container).attr('data-section-id');
  this.namespace = '.collection-' + this.sectionId;

  this.init();
}

Collection.prototype = $.extend({}, Collection.prototype, {
  init: function() {
    this.$container = $(this.container);

    var sectionId = this.sectionId = this.$container.attr(
      'data-section-id'
    );

    this.namespace = '.collection-' + sectionId;

    this.$sortSelect = $(selectors.sortSelect);
    this.$sortSelect.on('change', this.onSortChange.bind(this));
    this.defaultSort = this.getDefaultSortValue();

    this.initParams();
    this.colorSwatchHovering();

    theme.reinitSection('collection-sidebar');
  },

  initParams: function() {
    this.queryParams = {};

    if (location.search.length) {
      var aKeyValue;
      var aCouples = location.search.substr(1).split('&');

      for (var i = 0; i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');

        if (aKeyValue.length > 1) {
          this.queryParams[
            decodeURIComponent(aKeyValue[0])
          ] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
  },

  getSortValue: function() {
    return this.$sortSelect.val() || this.defaultSort;
  },

  getDefaultSortValue: function() {
    return this.$sortSelect.attr(data.sortBy);
  },

  onSortChange: function() {
    this.queryParams.sort_by = this.getSortValue();

    if (this.queryParams.page) {
      delete this.queryParams.page;
    }

    window.location.search = $.param(this.queryParams);
  },

  colorSwatchHovering: function() {
    var $colorImage = $(selectors.colorSwatchImage);

    if (!$colorImage.length) {
      return;
    }

    $(selectors.colorSwatch).on({
      mouseenter: function (evt) {
        $el = $(evt.currentTarget);

        var id = $el.data('variant-id');
        var image = $el.data('variant-image');

        $('.grid-product__color-image--' + id)
          .css('background-image', 'url(' + image + ')')
          .addClass('is-active');
      },

      mouseleave: function (evt) {
        $el = $(evt.currentTarget);

        var id = $el.data('variant-id');

        $('.grid-product__color-image--' + id)
          .removeClass('is-active');
      }
    });
  },

  forceReload: function() {
    this.onUnload();
    this.init();
  },

  onUnload: function() {
    $(window).off(this.namespace);
    this.$container.off(this.namespace);
    $(selectors.colorSwatch).off(this.namespace);
  }
});